export default __webpack_public_path__ + "static/media/img-12-thelxion.76e97c21.jpg";